import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    brands: Array,
  };

  static targets = ['brand', 'primaryColor', 'secondaryColor'];

  setColorsFromBrand({ target }) {
    const id = Number(target.value);
    const brand = this.brandsValue.find((value) => value.id === id);

    this.primaryColorTarget.value = brand.primary_color;
    this.setColorPreviewColor(this.primaryColorTarget);

    this.secondaryColorTarget.value = brand.secondary_color;
    this.setColorPreviewColor(this.secondaryColorTarget);
  }

  updateColorPreview({ target }) {
    this.brandTarget.value = '';
    this.setColorPreviewColor(target);
  }

  setColorPreviewColor(target) {
    const hex = target.value;
    const hexRegex = /^#([0-9A-F]{6})$/i;
    const colorPreview = document.getElementById(target.dataset.previewId);

    if (hexRegex.test(hex)) {
      colorPreview.style.backgroundColor = hex;
    } else {
      colorPreview.style.backgroundColor = 'transparent';
    }
  }
}
